export const LANGUAGE_COOKIE_NAME = 'NPX-CLIENT-LANGUAGE';
export const TIMEZONE_COOKIE_NAME = 'NPX-CLIENT-TIMEZONE';
export const LOCALE_COOKIE_NAME = 'NPX-CLIENT-LOCALE';